export default "__VITE_ASSET__DfMdPKEZ__"